import * as React from "react";
const SvgIconMenuLogo = props => <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} style={{
  shapeRendering: "geometricPrecision",
  textRendering: "geometricPrecision",
  imageRendering: "optimizeQuality",
  fillRule: "evenodd",
  clipRule: "evenodd"
}} {...props}><path fill="#1c91bb" d="M32.5 6.5q-3.36 1.2-3 5-4.149-3.85 1.5-6 1.148.105 1.5 1" style={{
    opacity: 0.741
  }} /><path fill="#127aaf" d="M32.5 6.5q-.894 2.847 0 5v2h-1q-.5-1.5-2-2-.36-3.8 3-5" style={{
    opacity: 1
  }} /><path fill="#0597cc" d="M10.5 9.5q1.487-.258 2 1-2.726 3.015-6 1 1.18-2.405 4-2" style={{
    opacity: 0.999
  }} /><path fill="#135495" d="M32.5 6.5q4 2.5 0 5-.894-2.153 0-5" style={{
    opacity: 0.973
  }} /><path fill="#0987bc" d="M10.5 9.5q1.063-1.356 3-1 .954 3.442 4 5v2q-2.242-.733-4-2a5.73 5.73 0 0 0-1-3q-.513-1.258-2-1" style={{
    opacity: 0.996
  }} /><path fill="#0371b0" d="M13.5 8.5q2.188-.1 4 1 .35 2.343 2 4h-2q-3.046-1.558-4-5" style={{
    opacity: 1
  }} /><path fill="#1a93c3" d="M12.5 10.5q.915 1.337 1 3h-7l-2 1h-1a6.54 6.54 0 0 1 3-3q3.274 2.015 6-1" style={{
    opacity: 0.533
  }} /><path fill="#1b4c92" d="M17.5 9.5q7.38 2.38 10 10-.186.91-1 1a28 28 0 0 0-5-5q-.5-1.5-2-2-1.65-1.657-2-4" style={{
    opacity: 1
  }} /><path fill="#194a99" d="M8.5 13.5h3l1 2q-2.975.515-4-2" style={{
    opacity: 0.933
  }} /><path fill="#0176b3" d="M17.5 13.5h2q1.5.5 2 2h-4z" style={{
    opacity: 1
  }} /><path fill="#213f7d" d="M11.5 13.5h2q1.758 1.267 4 2v1a20.7 20.7 0 0 0-5-1z" style={{
    opacity: 0.612
  }} /><path fill="#056bab" d="M3.5 14.5h1q.915 1.336 1 3h-4z" style={{
    opacity: 1
  }} /><path fill="#0862a4" d="M6.5 13.5q.405 2.895 3 4 0 1-1 1-1.063-1.356-3-1a5.73 5.73 0 0 0-1-3z" style={{
    opacity: 1
  }} /><path fill="#175398" d="M6.5 13.5h2q1.025 2.515 4 2-1.185 1.352-3 2-2.595-1.105-3-4" style={{
    opacity: 1
  }} /><path fill="#197bb0" d="M17.5 15.5h4q.35 2.343 2 4l-4-1-2-2z" style={{
    opacity: 1
  }} /><path fill="#1b8ec1" d="M31.5 13.5h1l1 4q-1.947-.924-3 0-1.456-2.193 1-4" style={{
    opacity: 0.922
  }} /><path fill="#1098c8" d="M32.5 12.5q4.956.966 4 6a5.73 5.73 0 0 0-3-1l-1-4z" style={{
    opacity: 1
  }} /><path fill="#0577b2" d="M1.5 17.5h4v2h-4z" style={{
    opacity: 1
  }} /><path fill="#066ea9" d="M5.5 17.5q1.937-.356 3 1 .258 1.488-1 2h-1q0-1-1-1z" style={{
    opacity: 0.987
  }} /><path fill="#0686bb" d="M33.5 17.5a5.73 5.73 0 0 1 3 1q.427 2.872-1 5-1.147-3.643-5-4v-2q1.053-.924 3 0" style={{
    opacity: 1
  }} /><path fill="#0283bd" d="M1.5 19.5h4q1 0 1 1a26.3 26.3 0 0 1-5 2z" style={{
    opacity: 1
  }} /><path fill="#187dbd" d="M15.5 18.5q-2 1.5 0 3h-3q.258-1.488-1-2 1.807-2.456 4-1" style={{
    opacity: 1
  }} /><path fill="#138bbc" d="M15.5 18.5q2.406 1.18 2 4l-2-1q-2-1.5 0-3" style={{
    opacity: 0.882
  }} /><path fill="#0e87b8" d="m19.5 18.5 4 1q.5 1.5 2 2-4.687 2.544-6-3" style={{
    opacity: 1
  }} /><path fill="#0274b1" d="M21.5 15.5a28 28 0 0 1 5 5q0 1-1 1-1.5-.5-2-2-1.65-1.657-2-4" style={{
    opacity: 0.992
  }} /><path fill="#0b88c0" d="M6.5 20.5h1v5q.257 1.488-1 2-.535-5.197-5-3v-2a26.3 26.3 0 0 0 5-2" style={{
    opacity: 1
  }} /><path fill="#165a99" d="M11.5 19.5q1.258.512 1 2l1 2q-1 0-1 1-2.81-2.094-1-5" style={{
    opacity: 0.957
  }} /><path fill="#0175b3" d="M12.5 21.5h3l2 1v3q-1.657-1.65-4-2z" style={{
    opacity: 1
  }} /><path fill="#0374b1" d="M30.5 19.5q3.853.357 5 4 .258 1.488-1 2-1.18-2.405-4-2z" style={{
    opacity: 1
  }} /><path fill="#00007f" d="M7.5 23.5q4 1 0 2z" style={{
    opacity: 0.008
  }} /><path fill="#095ea2" d="M13.5 23.5q2.343.35 4 2 .5 1.5 2 2 1.65 1.657 2 4-1.937.356-3-1 .192-2.444-3-4z" style={{
    opacity: 1
  }} /><path fill="#257cac" d="m17.5 22.5 4 2v1h-4z" style={{
    opacity: 1
  }} /><path fill="#0a62a2" d="M30.5 19.5v4q2.82-.405 4 2v1q-2.188-.1-4 1 0-3-3-3a29.5 29.5 0 0 0 3-5" style={{
    opacity: 1
  }} /><path fill="#0c97ca" d="M6.5 27.5q-4.178.876-5-3 4.465-2.197 5 3" style={{
    opacity: 0.974
  }} /><path fill="#204790" d="m13.5 23.5 2 3v2q-2.643-1.143-3-4 0-1 1-1" style={{
    opacity: 0.91
  }} /><path fill="#087bb7" d="M17.5 25.5h4q1 0 1 1-1 0-1 1h-2q-1.5-.5-2-2" style={{
    opacity: 0.788
  }} /><path fill="#184f9a" d="M26.5 24.5h1q3 0 3 3h-4q-2-1.5 0-3" style={{
    opacity: 1
  }} /><path fill="#244582" d="M21.5 25.5v-1h5q-2 1.5 0 3h-1a5.73 5.73 0 0 0-3-1q0-1-1-1" style={{
    opacity: 0.553
  }} /><path fill="#0d73ad" d="M19.5 27.5h2q1.404 2.211 4 3 0 1 1 1-2.325 1.83-5 0-.35-2.343-2-4" style={{
    opacity: 1
  }} /><path fill="#048ec5" d="M22.5 26.5a5.73 5.73 0 0 1 3 1v3q-2.596-.789-4-3 0-1 1-1" style={{
    opacity: 0.996
  }} /><path fill="#2693bd" d="M34.5 26.5q-1.5 2.5-4 4v-3q1.812-1.1 4-1" style={{
    opacity: 0.905
  }} /><path fill="#1f4791" d="M15.5 26.5q3.192 1.556 3 4-1.815-.648-3-2z" style={{
    opacity: 0.882
  }} /><path fill="#0899cc" d="M25.5 27.5h5v3q-1.812 1.1-4 1-1 0-1-1z" style={{
    opacity: 1
  }} /></svg>;
export { SvgIconMenuLogo as ReactComponent };
export default __webpack_public_path__ + "static/svg/icon-menu-logo.0b8a9214.svg";